export default __webpack_public_path__ + "static/media/FirstBase-5.ed041913.jpg";